const options = {
  utm_source: 'utm_source',
  utm_medium: 'utm_medium',
  utm_term: 'utm_term',
  utm_campaign: 'utm_campaign',
}

const hubspot = {
  init() {
    // Check for UTM URL parameters and set session data if they exist
    const urlParams = new URLSearchParams(window.location.search);
    const utmSource = urlParams.get(options.utm_source);
    const utmMedium = urlParams.get(options.utm_medium);
    const utmTerm = urlParams.get(options.utm_term);
    const utmCampaign = urlParams.get(options.utm_campaign);

    if (utmSource) sessionStorage.setItem(options.utm_source, utmSource);
    if (utmMedium) sessionStorage.setItem(options.utm_medium, utmMedium);
    if (utmTerm) sessionStorage.setItem(options.utm_term, utmTerm);
    if (utmCampaign) sessionStorage.setItem(options.utm_campaign, utmCampaign);

    // Start observing the document for dynamically added forms
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }
};

// Also listen for iframe load events as a fallback
const observer = new MutationObserver((mutations) => {
  mutations.forEach((mutation) => {
    mutation.addedNodes.forEach((node) => {
      if (node.nodeType === 1) {
        if (window.hsFormsOnReady) {
          const hsForms = window.hubspot?.form?.api?.getForms();

          if (hsForms && hsForms.length > 0) {
            hsForms.forEach((form) => {
              if (form) {
                if (form.isFormReady) {
                  const formElement = document.querySelectorAll(`[data-form-id="${form.id}"]`)[0];

                  if (formElement) {
                    const formFields = formElement.querySelectorAll('input');

                    formFields.forEach(field => {
                      setUtmFields(field, options.utm_source);
                      setUtmFields(field, options.utm_medium);
                      setUtmFields(field, options.utm_term);
                      setUtmFields(field, options.utm_campaign);
                    });
                  }
                }
              }
            });
          }
        }
      }
    });
  });
});

const setUtmFields = (field, sessionKey) => {
  if (!field || !sessionKey) return null;

  if (field.name === sessionKey) {
    const sessionValue = sessionStorage.getItem(sessionKey);
    field.value =!field.value && sessionValue ? sessionValue : field.value;
  }

  return;
};

export default hubspot;
